module.exports = __webpack_public_path__ + "static/media/number_not_allotted.6f4d6a69.png";